import { trackPage } from 'lib/omniture';
import { pageTrackingSelector } from 'selectors/analyticsSelectors';
import { isEmpty } from 'lib/util';
import observeStore from './observeStore';

function authStateKnown(userAuth) {
    if (Array.isArray(userAuth)) {
        const unknownStates = [
            'unknown_isp',
            'unknown_mvpd'
        ];
        return (userAuth.filter(auth => unknownStates.indexOf(auth) !== -1).length === 0);
    }
    return false;
}

let pageTracked = false;
export default function trackingObserver(store) {
    return observeStore(store, pageTrackingSelector, (currentTracking, nextTracking) => {
        const { analytics, page, userAuth, provider } = nextTracking;
        if (analytics && authStateKnown(userAuth) && page.name) {
            if (userAuth.length === 0 || (userAuth.length > 0 && !isEmpty(provider))) {
                // safe guard from tracking page views multiple times
                if (pageTracked && currentTracking.page.name === page.name) {
                    return;
                }
                trackPage(nextTracking);
                pageTracked = true;
            }
        }
    });
}



// WEBPACK FOOTER //
// ./app/lib/observe/trackingObserver.js